import React, { useEffect, useCallback, useState } from 'react';
import { Box, Paper, Typography, IconButton, Grid } from '@mui/material';
import TableComponent from '../../../common/table/Table';
import AxiosInstance from '../../../../server/AxioInstance';
import { DownloadingIcon, PublishIcon } from '../../../../shared/components/icon';
import { useDownload, useSnackbar } from '../../../../shared/context';

const columns = [
  { id: 'title', label: 'Titulo', align: 'center' },
  { id: 'typeRequest', label: 'Tipo de aprovação', align: 'center' },
  { id: 'registration_date_approval', label: 'Data Solicitação', align: 'center' },
  { id: 'download', label: 'Download', align: 'center' },
  { id: 'acao', label: 'Ação', align: 'center' },
];

const BodyPublishDocument = () => {
  const { handleDownload } = useDownload();
  const { showSnackbar } = useSnackbar();
  const [rows, setRows] = useState([]);

  const buttonDownload = (item, index) => {
    return (
      <IconButton
        aria-label='reprova'
        // onClick={() => handleGetFile(item)}
        onClick={() => handleDownload(item, index)}
      >
        <DownloadingIcon fontSize='large' color='primary' />
      </IconButton>
    );
  };

  const buttonPublish = (item) => {
    return (
      <IconButton aria-label='publish' onClick={() => handleSubmit(item)}>
        <PublishIcon fontSize='large' color='primary' />
      </IconButton>
    );
  };

  const handleSubmit = async (item) => {
    try {
      await AxiosInstance.post('/manipulate-documents/update-publish-document', item);
      showSnackbar({
        vertical: 'top',
        horizontal: 'right',
        message: 'Publicação feita com sucesso.',
        variant: 'success',
      });
      await GetData();
    } catch (error) {
      showSnackbar({
        vertical: 'top',
        horizontal: 'right',
        message: error.message,
        variant: 'error',
      });
    }
  };

  const GetData = useCallback(async () => {
    const result = await AxiosInstance.post(
      '/manipulate-documents/publish-document?user=' + localStorage.getItem('@gedy:user'),
    );
    const temp = result?.data?.rows?.map((item, index) => ({
      ...item,
      download: buttonDownload(item, index),
      acao: buttonPublish(item),
    }));
    setRows(temp);
  // eslint-disable-next-line
  }, []);

  useEffect(() => {
    GetData();
  }, [GetData]);

  return (
    <>
      <Box p={2} component={Paper}>
        <Box>
          <Typography variant='h4' mb={1}>
            Publicar documentos aprovados
          </Typography>
          <Grid container spacing={1}>
            <Grid item xs={12} md={12} xl={12}>
              <TableComponent columns={columns} rows={rows} />
            </Grid>
          </Grid>
        </Box>
      </Box>
    </>
  );
};

export default BodyPublishDocument;
